import React, { useState, useEffect } from "react";
import { Form, Button, Input, message, Modal, Select, Spin } from "antd";
import { useTranslation } from "react-i18next";
import { DownOutlined } from "@ant-design/icons";
import { apiClient } from "../Api/AllApi";
import { useParams } from "react-router-dom";

import "../Styles/AddProducts.css";

const UpdateCategory = () => {
  const [form1] = Form.useForm();
  const { t } = useTranslation();
  const { id } = useParams();
  const [nameKurdish, setNameKurdish] = useState("");
  const [nameArabic, setNameArabic] = useState("");
  const [description, setDescription] = useState("");
  const [status, setStatus] = useState("active");
  const [loading, setLoading] = useState(true);
  
  //todo this is Modal  Name
  const [isModalOpenNew, setIsModalOpenNew] = useState(false);

  const handleCancelNew = () => {
    setIsModalOpenNew(false);
  };
  const showModalNew = () => {
    setIsModalOpenNew(true);
  };

  const handleOkNew = () => {
    setIsModalOpenNew(false);
  };
  //! End modal
  useEffect(() => {
    const fetchCategory = async () => {
      try {
        const response = await apiClient.get(`/categories/${id}`);
        const category = response.data;
        if (category.name) {
          try {
            const parsedName = JSON.parse(category.name);
            setNameKurdish(parsedName.en);
            setNameArabic(parsedName.ar);
            form1.setFieldValue('kurdish', parsedName.en);
            form1.setFieldValue('arabic', parsedName.ar);
          } catch (e) {
            console.error('Error parsing name:', e);
          }
        }
        setDescription(category.description || '');
        setStatus(category.status || 'active');
        form1.setFieldValue('description', category.description || '');
        form1.setFieldValue('status', category.status || 'active');
        setLoading(false);
      } catch (error) {
        console.error('Error fetching category:', error);
        message.error(t("Failed to fetch category"));
        window.location.href = "/categories";
      }
    };

    fetchCategory();
  }, [id, t, form1]);
  const PostApi = async () => {
    try {
      if (!nameKurdish || !nameArabic) {
        message.error(t("Please enter both Kurdish and Arabic names"));
        return;
      }

      if (!status) {
        message.error(t("Please select a status"));
        return;
      }

      const formData = {
        name: JSON.stringify({
          en: nameKurdish,
          ar: nameArabic,
        }),
        status: status,
      };
      
      if (description) {
        formData.description = description;
      }

      const config = {
        headers: {
          'Content-Type': 'application/json'
        }
      };

      await apiClient.put(`/categories/${id}`, formData, config);

      message.success("Category updated successfully");
      window.location.href = "/categories";
    } catch (error) {
      console.error("Error:", error);
      message.error("Failed to update category. Please try again later.");
    }
  };

  //todo ---------------------------------------------------------------------
  const onFinish = (values) => {
    PostApi();
  };
  const onFinishFailed = (errorInfo) => {
    message.error("Error");
  };
  const handleResetCart = () => {
    form1.resetFields();
  };
  //todo  -----------------------------------------------

  const layout = {
    labelCol: {
      span: 4,
    },
    wrapperCol: {
      span: 16,
    },
  };

  if (loading) {
    return (
      <div style={{ display: "flex", justifyContent: "center", padding: 24 }}>
        <Spin size="large" />
      </div>
    );
  }
  return (
    <div style={{ textAlign: "center", marginTop: "50px", direction: "rtl" }}>
      <h1 style={{ fontSize: "24px", marginBottom: "20px" }}>
        {t("update category")}
      </h1>
      <Form
        form={form1}
        {...layout}
        style={{
          fontSize: "18px", // Global font size for the entire form
        }}
        labelCol={{ span: 6 }} // Adjusts label width
        wrapperCol={{ span: 16 }} // Adjusts input width
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        {/* //TODO: name products ============== */}
        <Form.Item name="name" label={t("name")}>
          <Button
            type="text"
            style={{
              border: "1px solid #ccc",
              borderRadius: "4px",
              width: "70%",
              fontSize: "16px",
              textAlign: "center",
              display: "inline-block",
              backgroundColor: "#f0f0f0",
              color: "#333",
              fontWeight: "bold",
              boxShadow: "2px 2px 4px rgba(0, 0, 0, 0.1)",
            }}
            onClick={showModalNew}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {nameKurdish || nameArabic ? `${nameKurdish} / ${nameArabic}` : t("enter category name")}
              <DownOutlined />
            </div>
          </Button>

          <Modal
            style={{
              direction: "rtl",
            }}
            title={t("enter category")}
            open={isModalOpenNew}
            onOk={handleOkNew}
            onCancel={handleCancelNew}
          >
            <Form
              form={form1}
              onFinishFailed={onFinishFailed}
              initialValues={{ remember: true }}
            >              <Form.Item
                name="kurdish"
                label={t("كوردى")}
                initialValue={nameKurdish}
              >
                <Input 
                  defaultValue={nameKurdish}
                  onChange={(e) => setNameKurdish(e.target.value)}
                />
              </Form.Item>
              <Form.Item
                name="arabic"
                label={t("عربي")}
                initialValue={nameArabic}
              >
                <Input 
                  defaultValue={nameArabic}
                  onChange={(e) => setNameArabic(e.target.value)}
                />
              </Form.Item>
            </Form>
          </Modal>
        </Form.Item>        {/* Description field */}
        <Form.Item name="description" label={t("Description")} initialValue={description}>
          <Input.TextArea
            style={{ width: "70%", fontSize: "16px" }}
            placeholder={t("Enter description")}
            defaultValue={description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </Form.Item>

        {/* Status field */}
        <Form.Item name="status" label={t("Status")} initialValue={status}>
          <Select
            style={{ width: "70%", fontSize: "16px", textAlign: "center" }}
            defaultValue={status}
            onChange={(value) => setStatus(value)}
            placeholder={t("Select status")}
          >
            <Select.Option value="active">{t("Active")}</Select.Option>
            <Select.Option value="inactive">{t("Inactive")}</Select.Option>
          </Select>
        </Form.Item>

        <Form.Item label=".">
          <Button
            type="primary"
            style={{
              backgroundColor: "green",
              borderColor: "green",
              fontSize: "16px",
            }}
            htmlType="submit"
            onClick={PostApi}
          >
            {t("Submit")}
          </Button>
          &nbsp; &nbsp;
          <Button
            type="primary"
            style={{
              backgroundColor: "red",
              borderColor: "red",
              fontSize: "16px",
            }}
            htmlType="button"
            onClick={handleResetCart}
          >
            {t("Reset")}
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default UpdateCategory;
